import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const MenuTabsWithLink = ({
  menu = [],

  classNames = "w-full",

  isLinkEnable = true,

  setActiveIndex = () => {},
}) => {
  const navigate = useNavigate();

  const location = useLocation();

  const { search } = location;

  const category = new URLSearchParams(search).get("category"); // Get category from query parameters

  const [active, setActive] = useState(menu?.indexOf(menu[0]) || 0);

  useEffect(() => {
    if (category) {
      setActive(menu?.findIndex((item) => item.key === category));
    }
  }, [category, menu]);

  return (
    <div className={`${classNames}`}>
      <div className="bg-gray-100 rounded-md p-2 shadow-md">
        <ul className="flex items-center justify-evenly gap-4">
          {Array.isArray(menu) &&
            menu.length > 0 &&
            menu.map((item, i) => (
              <li
                key={item?._id || i.toString()}
                className={`py-2 px-4 text-gray-700 rounded-md cursor-pointer transition-all ease-in-out duration-300 hover:bg-opacity-75 ${
                  active === i
                    ? "bg-blue-500 text-white w-[180px] text-center"
                    : "hover:bg-gray-200"
                }`}
                onClick={() => {
                  setActive(i);

                  setActiveIndex(i);

                  if (isLinkEnable) {
                    navigate(item?.link || "/");
                  }
                }}
                style={{ display: "inline-block" }}
              >
                {item?.label}
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default MenuTabsWithLink;
